import { render, staticRenderFns } from "./itemsTutorial.vue?vue&type=template&id=a5ca73ec&scoped=true"
import script from "./itemsTutorial.vue?vue&type=script&lang=js"
export * from "./itemsTutorial.vue?vue&type=script&lang=js"
import style0 from "./itemsTutorial.vue?vue&type=style&index=0&id=a5ca73ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ca73ec",
  null
  
)

export default component.exports